import { useGetVehicleId } from 'pages/CreateVehicle/hooks/useGetVehicleId';
import { useGetSectionsQuery } from 'services/api/vehicle-sections';

export const useLicensePlateExpiration = () => {
  const vehicleId = useGetVehicleId();
  const { data: sections } = useGetSectionsQuery(vehicleId);

  const tireImages = sections?.exterior?.subsections?.tires?.images || [];
  const licensePlateImage = tireImages.find(img => img.type === 'tires.license_plate_registration');
  return licensePlateImage?.expiration_date
};
